module.exports = __webpack_public_path__ + "fonts/TiemposHeadline-Bold.4262c570.woff2";